import moment from 'moment-timezone'
moment.tz.add('Asia/Shanghai|CST CDT|-80 -90|010101010101010101010101010|-1c2w0 Rz0 11d0 1wL0 A10 8HX0 1G10 Tz0 1ip0 1jX0 1cN0 11b0 1oN0 aL0 1tU30 Rb0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0|23e6');
moment.tz.setDefault("Asia/Shanghai");

/**
 * 固定时区获取时间:取代js的new Date，以避免时间变动的问题
 * format格式 'YYYY-MM-DD HH:mm:ss ZZ' 
 * 
 * 作者: ElvaChan
 */

var MOMENT_TIME = {

    /**
     * 根据时间戳获取时间的年月日时分秒(整型数组)
     * @param {时间戳} timeStamp 
     * @returns {年月日时分秒} [yy, mm, dd, hh, mi, ss]
     */
    getTimeArrayByTimeStamp(timeStamp) {
        var time = timeStamp ? moment(timeStamp) : moment(),
            yy   = parseInt(time.format('YYYY')),
            mm   = parseInt(time.format('MM')),
            dd   = parseInt(time.format('DD')),
            hh   = parseInt(time.format('HH')),
            mi   = parseInt(time.format('mm')),
            ss   = parseInt(time.format('ss'));
        return [yy, mm, dd, hh, mi, ss];
    },

    /**
     * 获取时间的周
     * @param {时间戳} timeStamp 
     */
    getTimeWeekDayByTimeStamp(timeStamp) {
        var time = timeStamp ? moment(timeStamp) : moment();
        return time.weekday();
    },

    /**
     * 根据格式化的字符串 获取unix时间戳
     * 格式'YYYY-MM-DD HH:mm:ss'
     * 注意:需要补满时分秒 00:00:00
     * @param {格式化的时间字符串} timeStr 
     * @returns {unix时间戳}
     */
    getUnixTimeByTimeStr(timeStr) {
        // 兼容处理:如果时间取出来为NaN的话，用new Date来取;
        var resultTime = moment(timeStr).unix(),
            newTimeStr = timeStr ? timeStr.replace(/-/gi, '/') : '';
        resultTime = !resultTime && newTimeStr != '' ? (new Date(newTimeStr).getTime() / 1000) : resultTime;
        return resultTime;
    },

    /**
     * 获取当前时间的时间戳
     */
    getTimeStampByNow() {
        return moment().unix();
    },

    /**
     * 根据时间戳获取格式化的时间字符串
     * 年月日
     * @param {时间戳} timeStamp 
     * @returns {年-月-日}
     */
    getFormateTimeYMDByTimeStamp(timeStamp) {
        return moment(timeStamp).format('YYYY-MM-DD');
    },

    /**
     * 根据时间戳获取格式化的时间字符串
     * 年月日时分
     * @param {时间戳} timeStamp 
     * @returns {年-月-日}
     */
    getFormateTimeYMDHmByTimeStamp(timeStamp) {
        return moment(timeStamp).format('YYYY-MM-DD HH:mm');
    },

    /**
     * 根据时间戳获取格式化的时间字符串
     * @param {时间戳} timeStamp 
     * @returns {年-月-日 时:分:秒}
     */
    getFormateTimeByTimeStamp(timeStamp) {
        return moment(timeStamp).format('YYYY-MM-DD HH:mm:ss');
    },

    /**
     * 根据时间戳获取年龄
     * @param {时间戳} timeStamp 
     * @returns {int} age
     */
    getAgeByTimeStamp(timeStamp) {
        var birthTime = this.getTimeArrayByTimeStamp(timeStamp);
        var nowTime = this.getTimeArrayByTimeStamp();
        var yearDiff, monthDiff, age;
        if(nowTime[1] - birthTime[1] >= 0){
            yearDiff = nowTime[0] - birthTime[0];
            monthDiff = nowTime[1] - birthTime[1];
        }else{
            yearDiff = nowTime[0] - 1 - birthTime[0];
            monthDiff = nowTime[1] + 12 - birthTime[1];
        }
        age = yearDiff + parseFloat(monthDiff / 12, 2);
        return Math.round(age*100)/100;
        // console.log('getAgeByTimeStamp----', timeStamp, birthTime, nowTime)
        // console.log(yearDiff, monthDiff, age)
    }


}

export {
    MOMENT_TIME
}
